// extracted by mini-css-extract-plugin
export default {"row":"row--En6et"};